import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ShipmentAppEntityShipmentRead, ShipmentService } from '../openapi';

@Injectable({
  providedIn: 'root'
})
export class ShipmentCommonService {
  constructor(
    private http: HttpClient,
    private shipmentService: ShipmentService
  ) {
  }

  public loadShipments(applicationId: string): Observable<ShipmentAppEntityShipmentRead[]> {
    return this.shipmentService.getShipmentCollectionShipmentCollection({
      pagination: false,
      sourceApplicationId: applicationId
    });
  }
}
